import { useCallback, useState, useMemo } from 'react'

export function usePagination(totalByPerPage = 10) {
    const [items, setItems] = useState([])
    const [page, setPage] = useState(1)

    const getPaginate = useCallback((items, perPage, currentPage) => {
        const offset = (currentPage - 1) * perPage
        return items.slice(offset, offset + perPage)
    }, [])

    const data = useMemo(() => {
        return getPaginate(items, totalByPerPage, page)
    }, [items, totalByPerPage, page, getPaginate])

    const count = useMemo(() => {
        return Math.ceil((items?.length || 1) / totalByPerPage)
    }, [items, totalByPerPage])

    const updatePagination = useCallback((newItems) => {
        setItems(newItems)
    }, [])

    const onPageChange = useCallback((newPage) => {
        setPage(newPage)
    }, [])

    return {
        items,
        data,
        count,
        page,
        updatePagination,
        onPageChange
    }
}
